import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPaginationRange, handleFilterChange } from "../../../../helpers";
import Table from "../../../../components/elements/table/Table";
import { leaderboardRoute, leaderBoardList } from "../../../../services/leaderboardService";
import TableControls from "../../../../components/elements/TableControls";
import Search from "../../../../components/form/Search";
import DatePicker from "../../../../components/form/DatePicker";
import dayjs from "dayjs";

const Leaderboard = () => {
  setTitle("Leaderboard");
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState({
    limit: 100,
    page: 1,
    // date: dayjs().format("YYYY-MM-DD"),
  });

  const [selectFilterItem, setSelectFilterItem] = useState([]);

  const { data, error, isLoading, updateData, isFetching, refetch } = useQuery({
    queryKey: ["leaderboard", filters, search, selectFilterItem],
    queryFn: async () => {
      const res = await leaderboardRoute({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "User",
      align: "left",
    },
    {
      _id: 2,
      name: "Global Rank",
      align: "left",
    },
    {
      _id: 3,
      name: "Earned Points",
      align: "left",
    },
    {
      _id: 4,
      name: "Badge",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item, i) => {
    return {
      _id: item?.userId,
      rowData: [
        {
          _id: 1,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          image: item?.image?.url,
          data: item?.firstName && item?.lastName ? `${item?.firstName} ${item?.lastName}` : "-",
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.rank != null ? item.rank.toString().padStart(3, "0") : "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.totalPoints,
        },
        {
          _id: 4,
          type: "imageWithText",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.badge?.name,
          image: item?.badge?.image?.url,
        },
      ],
    };
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="font-bold text-lg xl:text-3xl text-primary mb-8">Global Leaderboard</div>
      <div className="flex items-center gap-3">
        <div className="w-72">
          <Search
            placeholder="Search here"
            search={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
        </div>
        <div className="flex items-center gap-2 border rounded-lg pl-3 shadow-sm h-[40px] w-[300px] bg-white">
            <i className="fa-regular fa-calendar text-gray-700"></i>
            <DatePicker
              label=""
              placeholder="Pick a date"
              position="relative"
              onChange={({ startDate }) => {
                handleFilterChange("page", 1, setFilters);
                setFilters((prev) => ({
                  page:prev.page,
                  limit:prev.limit,
                  ...(startDate && {date: dayjs(startDate).format("YYYY-MM-DD")}),
                }));
              }}
              inputClassName="
      border-0 bg-transparent
      focus:ring-0 focus:outline-none
      text-sm font-medium text-gray-700 placeholder:text-gray-400
      w-full h-[38px] px-0
    "
              containerClassName="flex-1"
            />
          </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        totalDataCount={data?.metadata?.totalDocs}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        originalData={[...(data?.data || [])]}
        setOriginalData={(data) =>
          queryClient.setQueryData(["leaderboard", filters, search], (state) => {
            if (state) {
              return { ...state, data: data };
            }
          })
        }
        isFetching={isFetching}
        isOrderingDisabled={true}
        tableActionDropdownContainer={"!w-48"}
        showingData={getPaginationRange(filters?.page, filters?.limit, data?.metadata?.totalDocs)}
      />
    </div>
  );
};

export default Leaderboard;
